<template>
  <yams-template>
    <template #header>
      <div class="mr-5">
        <h4 class="text-primary font-weight-bold">Achats ({{ lines }})</h4>
      </div>
      <div class="mr-4">
        <NavComptabilite></NavComptabilite>
      </div>
      <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
        <button type="button" class="btn " @click.prevent="changeAffichage('table')"
          :class="{ 'active': affichage === 'table' }">
          <i class="fa-solid fa-bars"></i>
        </button>
        <button type="button" class="btn " @click.prevent="changeAffichage('card')"
          :class="{ 'active': affichage === 'card' }">
          <i class="fa-solid fa-border-all"></i>
        </button>
      </div>
      <div class="px-1">
        <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
          Ajouter un achat <i class="fa-solid fa-plus"></i>
        </button>
      </div>
    </template>
    <template #content>
      <div class="card mb-5">
        <div class="card-body p-1">
          <DataTableBackend :key="key" url="/api/achats" :columns="columns"
            :view-mode="affichage" :table="table" @row-click="openShowModal" @set-selected-rows="getSelection"
            v-on:set-total-records="updateLines">
            <template #statut="slotProps">
              <span class="p-2 rounded-pill badge" :class="{
                'badge-primary': slotProps.data.statut === 'En course',
                'badge-success': slotProps.data.statut === 'Disponible',
                'badge-danger': slotProps.data.statut === 'Indisponible',
                'badge-warning': slotProps.data.statut === 'En intervention',
                'badge-secondary': slotProps.data.statut === 'Nouveau'
              }">
                {{ slotProps.data.statut }}
              </span>
            </template>
          </DataTableBackend>
        </div>
      </div>
    </template>
  </yams-template>

</template>
<script>
import $ from "jquery"
import { defineComponent, defineAsyncComponent } from 'vue';
import NavComptabilite from '@/views/comptabilite/NavComptabilite.vue'
const CreateAchat = defineAsyncComponent(() => import('@/views/comptabilite/achats/CreateAchat.vue'));
const ShowAchat = defineAsyncComponent(() => import('@/views/comptabilite/achats/ShowAchat.vue'));

export default defineComponent({
  components: { NavComptabilite },
  name: 'IndexAchat',
  data() {
    return {
      lines: 0,
      key: 1,
      isLoading: true,
      table: 'achats',
      affichage: "table",
      selection: [],
      columns: [
        {
          key: 'date_operation',
          label: 'Date',
          format: 'date',
          exportable: true
        },
        {
          key: 'acheteur',
          label: 'Acheteur',
          exportable: true,
          sortable: true
        },
        {
          key: 'fournisseur.nom',
          label: 'Fournisseur',
          exportable: true,
          sortable: true
        },
        {
          key: 'montant',
          label: 'Montant',
          format: 'money',
          exportable: true,
          sortable: true
        },
        {
          key: 'statut_reglement',
          label: 'Reglement',
          format: 'state',
          exportable: true,
          sortable: true
        },
        {
          key: 'statut',
          label: 'Statut',
          // format: 'state'
        }
      ]
    };
  },
  methods: {
    changeAffichage(type) {
      this.affichage = type;
      this.key++
    },
    getSelection(selection) {
      this.selection = selection
    },
    openShowModal(objData) {
      this.$dialog.open(ShowAchat, {
        props: {
          header: "Achat ID" + objData.id,
          style: {
            width: '80vw'
          },
          modal: true
        },
        data: objData
      });
    },
    openCreateModal() {
      this.$dialog.open(CreateAchat, {
        props: {
          header: "Nouvel achat",
          style: {
            width: '80vw'
          },
          modal: true
        }
      });
    },
    updateLines(nb_lines) {
      this.lines = nb_lines
    }
  }
});
</script>